/**
 * Copyright © Veeam Software Group GmbH.
 */

export const getEndOfTheDay = (day: Date): Date => new Date(new Date(day).setHours(23, 59, 59, 999));
